var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "1000px", height: "700px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v("House B/L Information"),
        ]),
        _c(
          "div",
          { staticClass: "content_box mt10", attrs: { id: "frmReq" } },
          [
            _c("table", { staticClass: "tbl_search" }, [
              _vm._m(0),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("House B/L No.")]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fwdrBlNo,
                          expression: "fwdrBlNo",
                        },
                      ],
                      staticClass: "wid200",
                      attrs: { type: "text", readonly: "" },
                      domProps: { value: _vm.fwdrBlNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.fwdrBlNo = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "content_box mt10" }, [
          _c("table", { staticClass: "tbl" }, [
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c("div", { staticClass: "tab" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          staticClass: "on",
                          attrs: { id: "tab1" },
                          on: {
                            click: function ($event) {
                              return _vm.selectTab(1)
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v("Shipper"),
                          ]),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          attrs: { id: "tab2" },
                          on: {
                            click: function ($event) {
                              return _vm.selectTab(2)
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v("Cargo"),
                          ]),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          attrs: { id: "tab3" },
                          on: {
                            click: function ($event) {
                              return _vm.selectTab(3)
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v("Body Detail"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 1,
                          expression: "tapState === 1",
                        },
                      ],
                      staticClass: "content_box",
                    },
                    [
                      _c("house-bl-shipper", {
                        ref: "shipping",
                        attrs: { "parent-info": _vm.parentParam },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 2,
                          expression: "tapState === 2",
                        },
                      ],
                      staticClass: "content_box",
                    },
                    [
                      _c("house-bl-cargo", {
                        ref: "cargo",
                        attrs: { "parent-info": _vm.parentParam },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 3,
                          expression: "tapState === 3",
                        },
                      ],
                      staticClass: "content_box",
                    },
                    [
                      _c("house-bl-container", {
                        ref: "container",
                        attrs: { "parent-info": _vm.parentParam },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  return _vm.gethouseBlInfo()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ONEX050G020.027")))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ONEX060P012.068")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "200px" } }),
      _c("col"),
      _c("col", { attrs: { width: "100px" } }),
      _c("col"),
      _c("col", { attrs: { width: "100px" } }),
      _c("col"),
      _c("col", { attrs: { width: "100px" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }